module.exports = __webpack_public_path__ + "static/mindmap-edb92aa31b7906206a8c3fcfdc9dd3dd.png";